module.exports = __webpack_public_path__ + "images/estate-c71efd9dcb1ae76ccb31188f834a9268.svg";